import React from 'react'
import { AppSidebar } from '@/components/AppSidebar'
import { IntroGate } from '@/components/IntroGate'
import { LoadingGate } from '@/components/LoadingGate'

// Shell aplikasi — reproduksi V1 app/layout.tsx (sidebar fixed + konten ml-14),
// lalu IntroGate + LoadingGate. Providers dibungkus di main.tsx (level root).
export function Layout({ children }: { children: React.ReactNode }) {
  return (
    <>
      <div id="app-shell">
        {/* Sidebar fixed, konten punya margin-left 56px (lebar collapsed) */}
        <AppSidebar />
        <div className="ml-14 min-h-screen">
          {children}
        </div>
      </div>
      <IntroGate />
      <LoadingGate />
    </>
  )
}
